import React from "react";

// 챗 카드 컴포넌트
const ChatCard = ({ children, isUser, agent, color, brandId }) => {
  const isButtonGroup = children && children[0]?.props?.children?.length && children[0]?.props?.children?.length >= 0;
  const landersClass = brandId === "LD" && `${isButtonGroup && "border-none !px-0 py-[1px] !bg-transparent"}`;

  return (
    <div
      className={`flex items-center mb-2.5 ${
        !isUser ? "justify-start" : "justify-end"
      }`}
    >
      <div
        className={`inline-block py-3.5 px-6 mx-5 text-brand-text-black font-medium border ${
          !agent
            ? !isUser
              ? `border-brand-point bg-white rounded-custom-reverse ${landersClass}`
              : "border-neutral-400 bg-neutral-50 rounded-custom"
            : !isUser
              ? "bg-purple-c-50 border-purple-c-900 rounded-custom-reverse"
              : "border-neutral-400 bg-neutral-50 rounded-custom !mx-0"
        }`}
      >
        {children}
      </div>
    </div>
  )
};

export default ChatCard;
